import Vue from 'vue'

export const XVtableSetRowStateProperty = XVtablename => (state, { index, stateProperty, statePropertyValue }) => {
  // zoek de originele Store table row op en zet de state van
  let rij = state[XVtablename].tabledata.filter(rij => rij.tableRowState.storeTableindex === index)[0]
  Vue.set(rij.tableRowState, stateProperty, statePropertyValue)
}
export const XVtableGetRowStateProperty = XVtablename => state => ({ index, stateProperty }) => {
  // zoek de originele Store table index op en zet de state van
  return state[XVtablename].tabledata.filter(rij => {
    return rij.tableRowState.storeTableindex === index
  })[0].tableRowState[stateProperty]
}
export const XVtableGetValue = XVtablename => state => ({ index, columnname }) => {
  // zoek de originele Store table index op en zet de state van
  let coltype = state[XVtablename].tablecolumnsetting.filter(rij => rij.tblPEapiProcTableColumnName === columnname)[0]
    .tblPEapiProcTableColumnType
  if (coltype === 'date') {
    let datum = state[XVtablename].tabledata.filter(rij => rij.tableRowState.storeTableindex === index)[0][columnname]
    return datum === null ? null : new Date(datum) // als datum null is return null
  } else {
    return state[XVtablename].tabledata.filter(rij => rij.tableRowState.storeTableindex === index)[0][columnname]
  }
}
export const XVTablesort = XVtablename => (state, data) => {
  // Als er gesorteerd word dan kijken van deze column de tblPEapiProcTableColumnSortableDefault aanzetten.
  // Als deze column al gesorteerd is dan omdraaien (reverse). 1 is ascending, 2 is descending.
  // Nu is het default ascending. Wil je dit anders dan moet de 2 en 1 omgedraaid worden.
  data.tableColumnSettings.forEach((row, index) => {
    if (row.tblPEapiProcTableColumnName === data.sortkey) {
      if (row.tblPEapiProcTableColumnSortableDefault === 1) {
        row.tblPEapiProcTableColumnSortableDefault = 2
      } else {
        row.tblPEapiProcTableColumnSortableDefault = 1
      }
    } else {
      row.tblPEapiProcTableColumnSortableDefault = 0
    }
  })
}

export const XVtablecolumnsettingchanged = XVtablename => (state, input) => {
  // Lopen door de columnsettings. Als de column overeen komt met de column die in de input parameters zitten, dan deze visible aan of uit zetten.
  state[XVtablename].tablecolumnsetting.forEach((row, index) => {
    if (row.tblPEapiProcTableColumnName === input.column) {
      row.tblPEapiProcTableColumnVisible = input.tblPEapiProcTableColumnVisibleValue
    }
  })
}

export const initXVtableState = XVtablename => (state, data) => {
  if (data !== undefined) {
    state[XVtablename] = data
  }
  // alle detailrijen dichtgeklapt
  state[XVtablename].tabledata.forEach((row, index) => {
    Vue.set(row, 'tableRowState', {
      rowVisible: false,
      editModus: false,
      storeTableindex: index
    })
  })
  state[XVtablename].tablecolumnsetting.push({
    columnname: 'tableRowState',
    tblPEapiProcTableColumnName: 'tableRowState',
    tblPEapiProcTableColumnNameTextID: null,
    tblPEapiProcTableColumnSequence: state[XVtablename].tablecolumnsetting.length + 1,
    tblPEapiProcTableColumnSortColumn: null,
    tblPEapiProcTableColumnSortable: 0,
    tblPEapiProcTableColumnSortableDefault: 0,
    tblPEapiProcTableColumnType: null,
    tblPEapiProcTableColumnVisible: 0, // zet deze op visible om debuging info te krijgen van de tablerowstate
    tblPEapiProcTableColumnVisibleMD: null,
    tblPEapiProcTableColumnVisibleSM: null,
    tblPEapiProcTableColumnVisibleXS: null,
    tblPEapiProcTableColumnWidthMD: null,
    tblPEapiProcTableColumnWidthSM: null,
    tblPEapiProcTableColumnWidthXS: null,
    tblPEapiProcTableName: XVtablename,
    tblPEapiProcTableProcedure: '',
    tblPEapiProcTableColumnHelpTextID: null
  })
}

export const addXVtableState = XVtablename => (state, { data, uniqueIdentifier }) => {
  // functie is hetzelfe als de init, maar bij add worden de rijen er aan toegevoegd i.p.v. vervangen

  if (data !== undefined) {
    data.tablecolumnsetting.push({
      columnname: 'tableRowState',
      tblPEapiProcTableColumnName: 'tableRowState',
      tblPEapiProcTableColumnNameTextID: null,
      tblPEapiProcTableColumnSequence: state[XVtablename].tablecolumnsetting.length + 1,
      tblPEapiProcTableColumnSortColumn: null,
      tblPEapiProcTableColumnSortable: 0,
      tblPEapiProcTableColumnSortableDefault: 0,
      tblPEapiProcTableColumnType: null,
      tblPEapiProcTableColumnVisible: 0, // zet deze op visible om debuging info te krijgen van de tablerowstate
      tblPEapiProcTableColumnVisibleMD: null,
      tblPEapiProcTableColumnVisibleSM: null,
      tblPEapiProcTableColumnVisibleXS: null,
      tblPEapiProcTableColumnWidthMD: null,
      tblPEapiProcTableColumnWidthSM: null,
      tblPEapiProcTableColumnWidthXS: null,
      tblPEapiProcTableName: XVtablename,
      tblPEapiProcTableProcedure: '',
      tblPEapiProcTableColumnHelpTextID: null
    })

    // set een uniek gegeven op de tablecolumn settings zodat je daar op kan filteren op de pagina
    data.tablecolumnsetting.forEach(r => {
      r.uniqueIdentifier = uniqueIdentifier
    })

    if (state[XVtablename].tabledata.length === 0) {
      state[XVtablename] = data
      state[XVtablename].tabledata.forEach((row, index) => {
        Vue.set(row, 'tableRowState', {
          rowVisible: false,
          editModus: false,
          storeTableindex: index
        })
      })
    } else {
      state[XVtablename].tabledata = state[XVtablename].tabledata.concat(data.tabledata)
      state[XVtablename].tablecolumnsetting = state[XVtablename].tablecolumnsetting.concat(data.tablecolumnsetting)

      state[XVtablename].tabledata.forEach((row, index) => {
        Vue.set(row, 'tableRowState', {
          rowVisible: false,
          editModus: false,
          storeTableindex: index
        })
      })
    }
  }
}

export function setXVtableMutations(tablename) {
  const mutations = {
    XVtableSetRowStateProperty: XVtableSetRowStateProperty(tablename),
    XVTablesort: XVTablesort(tablename),
    XVtablecolumnsettingchanged: XVtablecolumnsettingchanged(tablename),
    initXVtableState: initXVtableState(tablename),
    addXVtableState: addXVtableState(tablename)
  }
  return mutations
}

// na PAUZE
//   export const initXVtableEditModus = XVtablename => (state, XVtableLength) => {
//     Vue.set(state[XVtablename], 'editmodus', Array(XVtableLength).fill(false))
//  }
